<template>
  <main-layout>
    <div class="releaseBox" @click="isShowUl=false,isShowUl1=false" id="view1">
      <div class="title">{{$t("recruit.发布职位")}}</div>
      <div class="info">
        {{$t("recruit.基本信息")}}
        <span>{{$t("recruit.职位名称和招聘类型发布后不可修改，请准确填写")}}</span>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('recruit.招聘类型')" prop="recruitNature">
          <el-select
            v-model="ruleForm.recruitNature"
            :placeholder="$t('recruit.请选择')"
            style="width: 160px;"
            :disabled="id?true: false"
          >
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('recruit.职位名称')" prop="positionName" class="positionName">
          <el-autocomplete
            v-model="ruleForm.positionName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入职位名称"
            :trigger-on-focus="false"
            @select="handleSelect"
            :disabled="id?true: false"
            ><template slot-scope="{item}">
                <div v-html="item.umName"></div>
              </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item :label="$t('recruit.经验和学历')" prop="experience">
          <el-select
            v-model="ruleForm.experience"
            :placeholder="$t('recruit.请选择工作经验')"
            style="width: 178px;"
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="ruleForm.education"
            :placeholder="$t('recruit.请选择学历')"
            style="width: 160px;margin-left: 12px;"
          >
            <el-option
              v-for="item in options3"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('recruit.薪资范围')" required>
          <div class="moneyBox clearfix">
            <div class="moneyStart">
              <el-select v-model="ruleForm.salaryBegin" placeholder="请选择" style="width: 160px;">
                <el-option
                v-for="item in moneyList"
                :key="item.value"
                :label="item.label"
                v-if="item.value!=260"
                :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="gang" v-if="ruleForm.salaryBegin!=9999">-</div>
            <div class="moneyStart" v-if="ruleForm.salaryBegin!=9999">
              <el-select v-model="ruleForm.salaryEnd" placeholder="请选择" style="width: 160px;" :disabled="!ruleForm.salaryBegin">
                <el-option
                  v-for="item in moneyList"
                  :key="item.value"
                  :label="item.label"
                  v-if="item.value > ruleForm.salaryBegin && item.value!=9999"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <el-checkbox v-model="ruleForm.negotiable" @change="changeBox">{{$t("recruit.面议")}}</el-checkbox> -->
        </el-form-item>
        <el-form-item :label="$t('recruit.职位类型')" prop="positionTypeJson">
          <div class="editBox clearfix">
            <div class="tagBox">
              <span v-for="(item,i) in ruleForm.positionTypeJson" :key="i">{{item.name}}</span>
            </div>
            <div class="edit" @click="editType">
              <img src alt />
              {{$t("recruit.编辑")}}
            </div>
          </div>
        </el-form-item>
        <div class="detailBox" id="view2">
          {{$t("recruit.职位详情")}}
          <span>{{$t("recruit.详细的职位介绍信息能帮助你更快找到合适的候选人")}}</span>
        </div>
        <el-form-item label="职位描述" prop="positionDes">
          <div class="example" @click="seeTip">{{$t("recruit.查看示例")}}</div>
          <el-input
            type="textarea"
            placeholder="请输入岗位职责、任职要求等，至少20字，建议使用短句并分条列出，如下
岗位职责：
1、……
2、……
任职要求：
1、……
2、……
            
请勿填写性别歧视词、违反劳动法相关内容，否则有可能会导致您的发布审核不通过。"
            v-model="ruleForm.positionDes"
            maxlength="5000"
            show-word-limit
            style="width: 540px;height: 274px;"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('recruit.工作地址')" prop="workAddressId">
          <div class="addressBox">
            <div
              :class="['addressName',ruleForm.workAddressId?'active':'']"
              @click.stop.prevent="addressAdd"
            >
              {{workAddressName}}
              <img src="https://image.manamana.net/1647496210000_vWcNLaEp" alt />
            </div>
            <!-- <ul v-if="isShowUl">
              <li
                v-for="(item,i) in addressList"
                :key="i"
                @click="changeWorkAddress(item)"
              >{{item.allName}}</li>
              <li class="addName" @click="addressAdd">+ {{$t("recruit.新增地址")}}</li>
            </ul> -->
          </div>
        </el-form-item>
        <el-form-item label="投递邮箱" prop="recruitEmailId">
          <div class="addressBox addressBox1">
            <div
              :class="['addressName',ruleForm.recruitEmailId?'active':'']"
              @click.stop.prevent="isShowUl1=!isShowUl1,isShowUl=false"
            >
              {{emailName}}
              <img src="https://image.manamana.net/1647496210000_vWcNLaEp" alt />
            </div>
            <ul v-if="isShowUl1">
              <li v-for="(item,i) in emailList" :key="i" @click.stop.prevent="changeEmail(item)">
                {{item.email}}
                <i @click.stop.prevent="deleteEmail(item.id)">x</i>
              </li>
              <li class="addName" @click="emailAdd">+ {{$t("recruit.新增邮箱")}}</li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="submit" @click="submit">{{$t("recruit.发布")}}</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="typePop" v-if="showTypeBox">
      <div class="typePopBox">
        <p class="type_title">
          {{$t("recruit.请选择职位分类")}}
          <span class="most">{{$t("recruit.最多选择2个")}}</span>
          <span class="close" @click="close"></span>
        </p>
        <div class="categoryLabel">
          <div class="label_title clearfix">
            <span
              v-for="(item, index) in typeList"
              :key="index"
              @click="changeIndustryIds(item)"
              :class="{ active: item.id == tagId }"
            >
              {{ language === "zh" ? item.name : item.enName || item.name }}
              <i
                v-if="amountNumber(item.id)"
              >({{ amountNumber(item.id) }})</i>
            </span>
          </div>
        </div>
        <div class="subdivide" v-if="subClassification.length">
          <p class="subdivide_title">{{$t("recruit.请选择此分类下的二级分类")}}</p>
          <div class="label_title clearfix">
            <span
              v-for="(item, index) in subClassification"
              :key="index"
              @click="changeIndustryIds1(item)"
              :class="{ active: isActive(item.id) }"
            >{{ language === "zh" ? item.name : item.enName || item.name }}</span>
          </div>
        </div>
        <div class="selected" v-if="selectTags.length">
          <p class="selected_title">
            {{ $t("video.已选择") }}{{ selectTags.length
            }}{{$t("recruit.个分类")}}
          </p>
          <div class="selected_label_title clearfix">
            <span v-for="(item, i) in selectTags" :key="i">
              {{ language === "zh" ? item.name : item.enName || item.name }}
              <i
                @click.stop.prevent="selectTag(item)"
              ></i>
            </span>
          </div>
        </div>
        <div class="determine" @click="dinfTags" v-if="selectTags.length">{{ $t("global.确定") }}</div>
      </div>
    </div>
    <div class="popBox" v-if="isShow">
      <div class="box" v-if="isShow1">
        <div class="title">
          <div class="top">{{$t("recruit.请选择工作地址")}}</div>
          <div class="bot">{{$t("recruit.职位发布成功后，工作城市不可修改")}}</div>
          <span @click="close1"></span>
        </div>
        <div class="contentBox">
          <div class="addressList" v-for="(item,i) in addressList" :key="i">
            <span
              @click="selectCity(item,i)"
              :class="[cityName && item.cityName !== cityName ? 'notC':'']"
            >
              <i v-if="workAddressId == item.id"></i>
            </span>
            <i :class="['name',cityName && item.cityName !== cityName ? 'notC':'']" @click="selectCity(item,i)">{{item.allName}}</i>
            <i
              class="xiugai"
              v-if="workAddressId == item.id"
              @click="addAdress(item)"
            >{{$t("recruit.修改")}}</i>
            <i
              class="shanchu"
              v-if="workAddressId == item.id"
              @click="deleteAdress(item.id)"
            >{{$t("recruit.删除")}}</i>
          </div>
          <div class="addAddress" @click="addAdress(null)">{{$t("recruit.新增地址")}}</div>
        </div>
        <div class="but">
          <span @click="but1">{{$t("recruit.确定")}}</span>
        </div>
      </div>
      <div class="box" v-if="isShow2">
        <div class="title">
          {{textType == 1? $t("recruit.修改工作地址"): $t("recruit.新增工作地址")}}
          <span @click="close2"></span>
        </div>
        <div class="contentBox">
          <div class="city">
            <span>{{$t("recruit.城市")}}</span>
            <el-select
              v-model="cityId"
              filterable
              :placeholder="$t('recruit.请选择')"
              :disabled="id != null && textType == 1 ?true:false"
              style="width: 350px;"
            >
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.cityName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="city">
            <span>{{$t("recruit.详细地址")}}</span>
            <el-input
              type="text"
              :placeholder="$t('recruit.请输入内容')"
              v-model="detailAddress"
              style="width: 350px;"
            ></el-input>
          </div>
        </div>
        <div class="but">
          <span @click="but2">{{$t("recruit.确定")}}</span>
        </div>
      </div>
      <div class="box" v-if="isShow3">
        <div class="title">
          {{$t("recruit.新增投递邮箱")}}
          <span @click="close3"></span>
        </div>
        <div class="contentBox">
          <div class="city">
            <div class="inputTitle">{{$t("recruit.请在此处填写您的邮箱账号")}}</div>
            <el-input
              type="text"
              :placeholder="$t('recruit.请输入邮箱号')"
              style="width: 350px;"
              v-model="email"
            ></el-input>
          </div>
        </div>
        <div class="but">
          <span @click="but3">{{$t("recruit.确定")}}</span>
        </div>
      </div>
      <div class="box" v-if="isShow4">
        <div class="title">职位描述示例<span @click="close4"></span></div>
        <div class="contentBox1">
          <div class="title1">岗位职责：</div>
          <p>1.负责公司相关项目分镜头脚本的撰写；</p>
          <p>2.负责导演、监制、摄制等项目的创意策划；</p>
          <p>3.负责筹备、掌控所有影片的拍摄流程及后期包装成片。</p>
          <div class="title2">任职要求</div>
          <p>1.本科及以上学历，电视编导、新闻学、广告学等专业；</p>
          <p>2.3年以上导演或者编导相关工作经验，有参与或负责过文旅相关的演艺类作品；</p>
          <p>3.具有较强的沟通表达能力和策划能力；具有较强的执行力和团队协作能力，责任心强；</p>
          <p>4.具有深厚的文字功底，能独立完成影片文案的水平；</p>
          <p>5.熟悉影片的整体运作流程，能独立完成拍摄现场的统筹安排。</p>
        </div>
        <div class="but">
          <span @click="close4">{{$t("recruit.我知道了")}}</span>
        </div>
      </div> 
      <div class="box box1" v-if="isShow5">
        <div class="title">发布职位<span @click="close5"></span></div>
        <div class="contentBox2">
          <p v-if="!id" class="p1">本次发布将消耗<i> 1 </i>个职位数，发布后您{{comboType == 3 ? '的免费版':'购买的'}}套餐还剩余<i> {{comboNumber == -1 ? '无限': comboNumber - 1}} </i>个可用职位</p>
          <p class="p2">招聘性质和职位名称发布后<i>不可修改</i>，请确认</p>
          <p class="p3">招聘性质<span>{{ruleForm.recruitNature == 1?'全职':ruleForm.recruitNature == 2?'实习生':'兼职'}}</span></p>
          <p class="p3">职位名称<span>{{ruleForm.positionName}}</span></p>
          <div class="but1"><span class="closePop" @click="close5">取消</span><span class="config" @click="submitConfig">提交</span></div>
        </div>
        <div></div>
      </div>
    </div>
  </main-layout>
</template>
<script>
import MainLayout from "@/layouts/MainLayout";
export default {
  name: "releasePosition",
  metaInfo() {
    return {
      title: "MANA " + this.$t("global.招聘")
    };
  },
  data() {
    return {
      checked: false,
      ruleForm: {
        recruitNature: null,
        positionName: "",
        experience: null,
        education: null,
        salaryBegin: "",
        salaryEnd: "",
        negotiable: false,
        positionTypeJson: [],
        positionDes: "",
        workAddressId: "",
        recruitEmailId: ""
      },
      rules: {
        recruitNature: [
          {
            required: true,
            message: this.$t("recruit.请选择招聘类型"),
            trigger: "change"
          }
        ],
        positionName: [
          {
            required: true,
            message: this.$t("recruit.请输入职位名称"),
            trigger: "blur"
          }
        ],
        experience: [
          {
            required: true,
            message: this.$t("recruit.请选择工作经验"),
            trigger: "change"
          }
        ],
        positionTypeJson: [
          {
            required: true,
            message: this.$t("recruit.请选择职位类型"),
            trigger: "blur"
          }
        ],
        positionDes: [
          {
            required: true,
            message: this.$t("recruit.请输入职位描述"),
            trigger: "blur"
          }
        ],
        workAddressId: [
          {
            required: true,
            message: this.$t("recruit.请选择工作地址"),
            trigger: "change"
          }
        ],
        recruitEmailId: [
          {
            required: true,
            message: this.$t("recruit.请选择投递地址"),
            trigger: "change"
          }
        ]
      },
      options1: [
        { label: this.$t("recruit.全职"), value: "1" },
        { label: this.$t("recruit.实习生"), value: "2" },
        { label: this.$t("recruit.兼职"), value: "4" }
      ],
      options2: [
        { label: this.$t("recruit.不限"), value: "1" },
        { label: this.$t("recruit.1年以下"), value: "2" },
        { label: this.$t("recruit.1-3年"), value: "3" },
        { label: this.$t("recruit.3-5年"), value: "4" },
        { label: this.$t("recruit.5-10年"), value: "5" },
        { label: this.$t("recruit.10年以上"), value: "6" }
      ],
      options3: [
        { label: this.$t("recruit.不限"), value: "1" },
        { label: this.$t("recruit.大专"), value: "2" },
        { label: this.$t("recruit.本科"), value: "3" },
        { label: this.$t("recruit.硕士"), value: "4" },
        { label: this.$t("recruit.博士"), value: "5" }
      ],
      typeList: [],
      subClassification: [],
      showTypeBox: false,
      selectTags: [],
      tagId: null,
      addressList: [],
      emailList: [],
      cityList: [],
      isShow: false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      isShow5: false,
      workAddressId: null,
      detailAddress: "",
      cityId: null,
      addressId: null,
      email: "",
      id: null,
      workAddressName: this.$t("recruit.请选择工作地址"),
      workAddressName1: "",
      isShowUl: false,
      emailName: this.$t("recruit.请选择投递邮箱"),
      isShowUl1: false,
      typeIds: [],
      cityName: null,
      textType: null,
      comboType: null,
      comboNumber: 0,
      positionNameList: [],
      moneyList: [
        {'label': '面议', value: 9999},
        {'label': '1K', value: 1},
        {'label': '2K', value: 2},
        {'label': '3K', value: 3},
        {'label': '4K', value: 4},
        {'label': '5K', value: 5},
        {'label': '6K', value: 6},
        {'label': '7K', value: 7},
        {'label': '8K', value: 8},
        {'label': '9K', value: 9},
        {'label': '10K', value: 10},
        {'label': '11K', value: 11},
        {'label': '12K', value: 12},
        {'label': '13K', value: 13},
        {'label': '14K', value: 14},
        {'label': '15K', value: 15},
        {'label': '16K', value: 16},
        {'label': '17K', value: 17},
        {'label': '18K', value: 18},
        {'label': '19K', value: 19},
        {'label': '20K', value: 20},
        {'label': '21K', value: 21},
        {'label': '22K', value: 22},
        {'label': '23K', value: 23},
        {'label': '24K', value: 24},
        {'label': '25K', value: 25},
        {'label': '26K', value: 26},
        {'label': '27K', value: 27},
        {'label': '28K', value: 28},
        {'label': '29K', value: 29},
        {'label': '30K', value: 30},
        {'label': '35K', value: 35},
        {'label': '40K', value: 40},
        {'label': '45K', value: 45},
        {'label': '50K', value: 50},
        {'label': '55K', value: 55},
        {'label': '60K', value: 60},
        {'label': '65K', value: 65},
        {'label': '70K', value: 70},
        {'label': '75K', value: 75},
        {'label': '80K', value: 80},
        {'label': '85K', value: 85},
        {'label': '90K', value: 90},
        {'label': '95K', value: 95},
        {'label': '100K', value: 100},
        {'label': '110K', value: 110},
        {'label': '120K', value: 120},
        {'label': '130K', value: 130},
        {'label': '140K', value: 140},
        {'label': '150K', value: 150},
        {'label': '160K', value: 160},
        {'label': '170K', value: 170},
        {'label': '180K', value: 180},
        {'label': '190K', value: 190},
        {'label': '200K', value: 200},
        {'label': '210K', value: 210},
        {'label': '220K', value: 220},
        {'label': '230K', value: 230},
        {'label': '240K', value: 240},
        {'label': '250K', value: 250},
        {'label': '260K', value: 260},
      ],
      loading: false
    };
  },
  watch: {
    'ruleForm.positionName'(val) {
      if (val) {
        if (val.length > 30) {
          this.$message.error("职位名称长度不能超过30！");
          this.ruleForm.positionName = null;
        }
      }
    }
  },
  components: {
    MainLayout
  },
  created() {
    this.getPositionType();
    this.getAddress();
    this.getEmail();
    this.getAllCity();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail(this.id);
    }
  },
  destroyed() {
    document.body.style.overflow = "";
  },
  methods: {
    handleSelect(item) {
      this.ruleForm.positionName = item.name;
    },
    querySearchAsync(query, cb) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.$http
            .get("/api/u/recruit/info/search/position_name/" + query)
            .then(res => {
              var data = res.data;
              data.forEach(item => {
                this.$set(item, 'value', item.umName)
              })
              cb(data)
            });
          }, 200);
        }
    },
    changeBox(value) {
      if (value) {
        this.ruleForm.salaryBegin = null;
        this.ruleForm.salaryEnd = null;
      }
    },
    getDetail(id) {
      this.$http.get("/api/u/recruit/info/" + id).then(res => {
        if (res.code == "OK") {
          this.ruleForm.recruitNature = res.data.recruitNature;
          this.ruleForm.positionName = res.data.positionName;
          this.ruleForm.experience = res.data.experience;
          this.ruleForm.education = res.data.education;
          this.ruleForm.negotiable = res.data.negotiable == 0 ? false : true;
          if (this.ruleForm.negotiable == 0) {
            this.ruleForm.salaryBegin = res.data.salaryBegin;
            this.ruleForm.salaryEnd = res.data.salaryEnd;
          } else {
            this.ruleForm.salaryBegin = 9999;
            this.ruleForm.salaryEnd = null;
          }
          if (res.data.recruitPositionTypeList.length) {
            for (let i = 0; i < res.data.recruitPositionTypeList.length; i++) {
              this.ruleForm.positionTypeJson.push({
                pTypeId: res.data.recruitPositionTypeList[i].ptypeId,
                typeId: res.data.recruitPositionTypeList[i].typeId,
                name: res.data.recruitPositionTypeList[i].showName
              });
              if (res.data.recruitPositionTypeList[i].ptypeId == 1) {
                this.changeIndustryIds({
                  id: res.data.recruitPositionTypeList[i].ptypeId,
                  typeId: res.data.recruitPositionTypeList[i].typeId,
                  name: res.data.recruitPositionTypeList[i].ptypeName,
                  child: this.typeList[6].child
                });
                this.changeIndustryIds1({
                  pid: res.data.recruitPositionTypeList[i].ptypeId,
                  id: res.data.recruitPositionTypeList[i].typeId,
                  name: res.data.recruitPositionTypeList[i].typeName
                });
              } else {
                this.changeIndustryIds({
                  id: res.data.recruitPositionTypeList[i].ptypeId,
                  typeId: res.data.recruitPositionTypeList[i].typeId,
                  name: res.data.recruitPositionTypeList[i].ptypeName,
                  child: []
                });
              }
            }
          }
          this.ruleForm.positionDes = res.data.positionDes;
          this.ruleForm.workAddressId = res.data.workAddressId;
          this.workAddressId = res.data.workAddressId;
          this.ruleForm.recruitEmailId = res.data.recruitEmailId;
          this.workAddressName = res.data.allAddressName;
          this.cityName = res.data.cityName;
          this.emailName = res.data.recruitEmailAddress;
        }
      });
    },
    deleteAdress(id) {
      this.$http.delete("/api/u/recruit/address/" + id).then(res => {
        if (res.code == "OK") {
          this.getAddress();
          this.workAddressId = null;
        }
      });
    },
    deleteEmail(id) {
      this.$http.delete("/api/u/recruit/email/" + id).then(res => {
        if (res.code == "OK") {
          this.getEmail();
          this.emailName = this.$t("recruit.请选择投递邮箱");
          this.ruleForm.recruitEmailId = "";
        }
      });
    },
    getPositionType() {
      this.$http.get("/api/recruit/positionType/").then(res => {
        if (res.code == "OK") {
          this.typeList = res.data;
        }
      });
    },
    editType() {
      document.body.style.overflow = "hidden";
      this.showTypeBox = true;
    },
    close() {
      document.body.style.overflow = "";
      this.showTypeBox = false;
    },
    changeIndustryIds(item) {
      this.subClassification = [];
      this.tagId = item.id;
      if (item.child.length) {
        this.subClassification = item.child;
      } else {
        this.selectTag({
          pTypeId: item.id,
          typeId: 0,
          name: item.name
        });
      }
    },
    changeIndustryIds1(item) {
      this.selectTag({
        pTypeId: item.pid,
        typeId: item.id,
        name: item.name
      });
    },
    isActive(id) {
      let index = this.typeIds.indexOf(id);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    selectTag(item) {
      if (item.typeId !== 0) {
        var index1 = this.typeIds.indexOf(item.typeId);
        if (index1 !== -1) {
          this.typeIds.splice(index1, 1);
        } else {
          if (this.selectTags.length >= 2) {
            this.$message.error(this.$t("recruit.最多选择2个"));
            return;
          }
          this.typeIds.push(item.typeId);
        }
      }
      if (this.selectTags.length) {
        let index = this.selectTags.findIndex(
          val =>
            val["pTypeId"] === item["pTypeId"] &&
            val["typeId"] === item["typeId"]
        );
        if (index !== -1) {
          this.selectTags.splice(index, 1);
        } else {
          if (this.selectTags.length >= 2) {
            this.$message.error(this.$t("recruit.最多选择2个"));
            return;
          }
          this.selectTags.push(item);
        }
      } else {
        this.selectTags.push(item);
      }
    },
    dinfTags() {
      this.ruleForm.positionTypeJson = this.selectTags;
      this.showTypeBox = false;
      document.body.style.overflow = "";
    },
    amountNumber(id) {
      let amount = 0;
      if (this.selectTags.length) {
        for (let i = 0; i < this.selectTags.length; i++) {
          if (this.selectTags[i].pTypeId == id) {
            amount++;
          }
        }
      }
      return amount;
    },
    getAddress() {
      this.$http.get("/api/u/recruit/address/").then(res => {
        if (res.code == "OK") {
          this.addressList = res.data;
        }
      });
    },
    getEmail() {
      this.$http.get("/api/u/recruit/email/").then(res => {
        if (res.code == "OK") {
          this.emailList = res.data;
        }
      });
    },
    getAllCity() {
      this.$http.get("/api/u/recruit/address/city").then(res => {
        if (res.code == "OK") {
          this.cityList = res.data;
        }
      });
    },
    addressAdd() {
      // document.body.style.overflow = "hidden";
      this.isShow = true;
      this.isShow1 = true;
    },
    changeWorkAddress(item) {
      this.ruleForm.workAddressId = item.id;
      this.workAddressName = item.allName;
      this.isShowUl = false;
    },
    changeEmail(item) {
      this.emailName = item.email;
      this.ruleForm.recruitEmailId = item.id;
      this.isShowUl1 = false;
    },
    emailAdd(e) {
      // document.body.style.overflow = "hidden";
      this.isShow = true;
      this.isShow3 = true;
    },
    close1() {
      document.body.style.overflow = "";
      this.isShow = false;
      this.isShow1 = false;
      document.getElementById("view2").scrollIntoView(true);
    },
    close2() {
      this.isShow2 = false;
      this.isShow1 = true;
    },
    close3() {
      document.body.style.overflow = "";
      this.isShow = false;
      this.isShow3 = false;
      document.getElementById("view2").scrollIntoView(true);
    },
    close4() {
      document.body.style.overflow = "";
      this.isShow = false;
      this.isShow4 = false;
      document.getElementById("view2").scrollIntoView(true);
    },
    close5() {
      this.isShow = false;
      this.isShow5 = false;
    },
    seeTip() {
      document.body.style.overflow = "hidden";
      this.isShow = true;
      this.isShow4 = true;
    },
    selectCity(item, i) {
      if (this.cityName && item.cityName != this.cityName) {
        return;
      }
      this.workAddressId = item.id;
      this.workAddressName1 = item.allName;
    },
    but1() {
      this.ruleForm.workAddressId = this.workAddressId;
      this.workAddressName = this.workAddressName1;
      this.close1();
      this.isShowUl = false;
      document.getElementById("view2").scrollIntoView(true);
    },
    but2() {
      let params;
      if (this.addressId) {
        params = {
          cityId: this.cityId,
          detail: this.detailAddress,
          id: this.addressId
        };
      } else {
        params = {
          cityId: this.cityId,
          detail: this.detailAddress
        };
      }
      this.$http
        .post("/api/u/recruit/address/", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code == "OK") {
            this.close2();
            this.getAddress();
          }
        });
    },
    but3() {
      if (
        this.email &&
        /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.email)
      ) {
        this.$http
          .post("/api/u/recruit/email/", { email: this.email })
          .then(res => {
            if (res.code == "OK") {
              this.close3();
              this.getEmail();
              document.getElementById("view2").scrollIntoView(true);
              this.emailName = res.data.email;
              this.ruleForm.recruitEmailId = res.data.id;
            }
          });
      } else {
        this.$message.error(this.$t("recruit.请输入正确的邮箱地址"));
      }
    },
    addAdress(item) {
      if (item) {
        this.detailAddress = item.detail;
        this.cityId = item.cityId;
        this.addressId = item.id;
        this.textType = 1;
      } else {
        this.detailAddress = "";
        this.cityId = null;
        this.addressId = null;
        this.textType = 2;
      }
      this.isShow2 = true;
      this.isShow1 = false;
    },
    submitConfig() {
      let params = null;
      if (this.id) {
        params = {
          id: Number(this.id),
          education: this.ruleForm.education,
          experience: this.ruleForm.experience,
          negotiable: this.ruleForm.negotiable ? "1" : "0",
          positionDes: this.ruleForm.positionDes,
          positionName: this.ruleForm.positionName,
          positionTypeJson: JSON.stringify(this.ruleForm.positionTypeJson),
          recruitEmailId: this.ruleForm.recruitEmailId,
          recruitEmailAddress: this.emailName,
          recruitNature: this.ruleForm.recruitNature,
          salaryBegin: this.ruleForm.salaryBegin==9999 ? null:this.ruleForm.salaryBegin,
          salaryEnd: this.ruleForm.salaryBegin==9999 ? null:this.ruleForm.salaryEnd,
          workAddressId: this.ruleForm.workAddressId
        };
      } else {
        params = {
          education: this.ruleForm.education,
          experience: this.ruleForm.experience,
          negotiable: this.ruleForm.negotiable ? "1" : "0",
          positionDes: this.ruleForm.positionDes,
          positionName: this.ruleForm.positionName,
          positionTypeJson: JSON.stringify(this.ruleForm.positionTypeJson),
          recruitEmailId: this.ruleForm.recruitEmailId,
          recruitEmailAddress: this.emailName,
          recruitNature: this.ruleForm.recruitNature,
          salaryBegin: this.ruleForm.salaryBegin==9999 ? null:this.ruleForm.salaryBegin,
          salaryEnd: this.ruleForm.salaryBegin==9999 ? null:this.ruleForm.salaryEnd,
          workAddressId: this.ruleForm.workAddressId
        };
      }
      if (this.id) {
        this.$http
          .put("/api/u/recruit/info/", params, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.code == "OK") {
              this.$router.push("/MyRecruit");
            }
          });
      } else {
        this.$http
          .post("/api/u/recruit/info/", params, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.code == "OK") {
              this.$router.push("/MyRecruit");
            }
          });
      }
      this.close5();
    },
    submit() {
      if (!this.ruleForm.recruitNature) {
        this.$message.error(this.$t("recruit.请选择招聘类型"));
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.ruleForm.positionName) {
        this.$message.error(this.$t("recruit.请输入职位名称"));
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.ruleForm.experience) {
        this.$message.error(this.$t("recruit.请选择工作经验"));
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.ruleForm.education) {
        this.$message.error(this.$t("recruit.请选择学历"));
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (this.ruleForm.salaryBegin&&this.ruleForm.salaryBegin==9999) {
        this.ruleForm.negotiable = true;
      } else {
        if (!this.ruleForm.salaryBegin) {
          this.$message.error(this.$t("recruit.请输入薪资范围"));
          document.getElementById("view1").scrollIntoView(true);
          return;
        }
        if (!this.ruleForm.salaryEnd) {
          this.$message.error(this.$t("recruit.请输入薪资范围"));
          document.getElementById("view1").scrollIntoView(true);
          return;
        }
      }
      // if (!this.ruleForm.negotiable) {
      //   if (!this.ruleForm.salaryBegin) {
      //     this.$message.error(this.$t("recruit.请输入薪资范围"));
      //     document.getElementById("view1").scrollIntoView(true);
      //     return;
      //   }
      //   if (!this.ruleForm.salaryEnd) {
      //     this.$message.error(this.$t("recruit.请输入薪资范围"));
      //     document.getElementById("view1").scrollIntoView(true);
      //     return;
      //   }
      //   if (
      //     Number(this.ruleForm.salaryBegin) > Number(this.ruleForm.salaryEnd)
      //   ) {
      //     this.$message.error(this.$t("recruit.薪资下限必须小于上限"));
      //     document.getElementById("view1").scrollIntoView(true);
      //     return;
      //   }
      // }
      if (!this.ruleForm.positionTypeJson.length) {
        this.$message.error(this.$t("recruit.请选择职位类型"));
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.ruleForm.positionDes) {
        this.$message.error(this.$t("recruit.请输入职位描述"));
        return;
      }
      if (!this.ruleForm.workAddressId) {
        this.$message.error(this.$t("recruit.请选择工作地址"));
        return;
      }
      if (!this.ruleForm.recruitEmailId) {
        this.$message.error(this.$t("recruit.请选择投递邮箱"));
        return;
      }
      if(!this.id){
        this.$http.get("/api/u/recruit/combo/current").then(res => {
          if (res.code == "OK") {
            if (res.data) {
              this.comboType = res.data.type;
              this.comboNumber = res.data.remainCount;
              if (this.comboNumber == 0) {
                this.$message.error(
                  "您套餐内的职位数已用完，要发布更多职位请升级招聘套餐或购买职位数。!"
                );
                return;
              }
              this.isShow = true;
              this.isShow5 = true
            } else {
              this.comboType = 3;
              this.comboNumber = 5;
              this.isShow = true;
              this.isShow5 = true;
            }
          }
        });
      }else {
        this.isShow = true;
        this.isShow5 = true;
      }
      
    }
  },
  computed: {
    language() {
      return this.$language();
    }
  }
};
</script>
<style>
.releaseBox .el-textarea__inner {
  height: 274px !important;
  border-radius: 0;
}
.releaseBox .el-input__inner {
  height: 36px;
  border-radius: 0;
}
.releaseBox .el-form-item {
  margin-bottom: 30px;
}
.releaseBox .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
</style>
<style lang="stylus" scoped>
.releaseBox {
  min-width: 1110px;
  width: 1110px;
  margin: 0 auto;
  padding: 40px 0 145px 0;

  .title {
    height: 20px;
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    line-height: 20px;
    margin-bottom: 30px;
  }

  .info {
    height: 25px;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    line-height: 25px;
    margin-bottom: 30px;

    span {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      margin-left: 10px;
    }
  }

  .moneyBox {
    .moneyStart {
      float: left;
      position: relative;

      i {
        position: absolute;
        right: 10px;
        top: 0;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }
    }

    .gang {
      float: left;
      margin: 0 14px;
    }
  }

  .editBox {
    .tagBox {
      float: left;

      span {
        display: inline-block;
        padding: 0 14px;
        height: 30px;
        line-height: 30px;
        background: #F5F5F5;
        margin-right: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }

    .edit {
      float: left;
      width: 73px;
      height: 30px;
      border: 1px solid #E0E0E0;
      line-height: 30px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-top: 5px;
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
    }
  }

  .detailBox {
    height: 25px;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    line-height: 25px;
    margin: 63px 0 38px 0;

    span {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      margin-left: 10px;
    }
  }

  .example {
    font-size: 14px;
    font-weight: 400;
    color: #2026CC;
    cursor: pointer;
  }

  .submit {
    margin-top: 40px;
    width: 95px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #2026CC;
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
    cursor: pointer;
  }

  .addressBox {
    width: 540px;
    position: relative;

    .addressName {
      width: 100%;
      height: 36px;
      position: relative;
      box-sizing: border-box;
      line-height: 36px;
      padding: 0 40px 0 15px;
      border: 1px solid #E0E0E0;
      color: #B8B8B8;
      cursor: pointer;

      img {
        width: 19px;
        height: 12px;
        position: absolute;
        right: 10px;
        top: 12px;
      }
    }

    .active {
      color: #333;
    }

    ul {
      position: absolute;
      width: 100%;
      border: 1px solid #E0E0E0;
      box-sizing: border-box;
      background: #FFFFFF;
      top: 36px;
      left: 0;
      z-index: 1;

      li {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        position: relative;

        i {
          position: absolute;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          right: 10px;
          top: 0;
        }

        &:hover {
          background: #F5F7FA;
        }
      }

      li.addName {
        color: #2026CC;
      }
    }
  }

  .addressBox1 {
    width: 252px;
  }
}

.typePop {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 111;

  .typePopBox {
    width: 730px;
    min-height: 270px;
    padding-bottom: 30px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .type_title {
      padding-left: 30px;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #E0E0E0;
      font-size: 18px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      position: relative;

      .most {
        font-size: 13px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        magrin-left: 12px;
      }

      .close {
        position: absolute;
        color: #999999;
        right: 24px;
        top: 25px;
        width: 13px;
        height: 13px;
        cursor: pointer;
        background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .categoryLabel {
      margin-top: 30px;
      padding: 0 30px;
    }

    .subdivide {
      margin-top: 30px;
      padding: 0 30px;

      .subdivide_title {
        font-size: 13px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 12px;
      }
    }

    .selected {
      margin: 88px 0 40px 0;
      padding: 0 30px;

      .selected_title {
        font-size: 13px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 12px;

        .uplimit {
          font-size: 13px;
          font-weight: 400;
          color: rgba(254, 86, 48, 1);
          margin-left: 20px;
        }
      }

      .selected_label_title {
        span {
          position: relative;
          float: left;
          padding: 0 24px 0 14px;
          height: 30px;
          line-height: 30px;
          background: rgba(32, 38, 204, 0.1);
          font-size: 14px;
          font-weight: 500;
          color: rgba(32, 38, 204, 1);
          margin: 0 10px 10px 0;

          i {
            color: #B8B8B8;
            cursor: pointer;
            position: absolute;
            width: 14px;
            height: 14px;
            right: 5px;
            top: 8px;
            background: url('/static/uploadvideo/tag_del_btn@2x.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }

    .determine {
      margin: 0 auto;
      width: 78px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      background: rgba(32, 38, 204, 1);
      cursor: pointer;
    }

    .label_title {
      span {
        display: inline-block;
        float: left;
        height: 30px;
        font-size: 14px;
        color: #666;
        line-height: 30px;
        font-weight: 400;
        padding: 0 12px;
        cursor: pointer;
        margin: 0 10px 10px 0;
        background: rgba(245, 245, 245, 1);
        box-sizing: border-box;

        &.active {
          color: #fff;
          background: rgba(32, 38, 204, 1);
        }
      }

      .clickaddtitle1 {
        display: inline-block;
        float: left;
        height: 30px;
        cursor: pointer;
        text-align: center;
        color: #666;
        font-weight: 400;
        margin: 0 10px 10px 0;
        line-height: 30px;
        font-size: 14px;
        border: 1px solid rgba(224, 224, 224, 1);
        box-sizing: border-box;
        padding: 0 13px;
      }

      .userinfortit1 {
        position: relative;
        float: left;
        // width: 150px;
        height: 30px;
        border: 1px solid rgba(32, 38, 204, 0.85);
        box-sizing: border-box;
        font-size: 0;

        input[type='text'] {
          font-size: 14px;
          padding-left: 10px;
          width: 150px;
          height: 100%;
          padding-left: 10px;
          padding-right: 38px;
          box-sizing: border-box;
          float: left;
        }

        a {
          position: absolute;
          right: 0;
          top: 0;
          padding: 0 5px;
          height: 30px;
          cursor: pointer;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          background: rgba(32, 38, 204, 0.08);
          font-weight: 500;
          color: rgba(32, 38, 204, 1);
        }
      }
    }
  }
}

.popBox {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 111;

  .box {
    width: 760px;
    padding-bottom: 40px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    .title {
      border-bottom: 1px solid #e0e0e0;
      position: relative;
      padding: 14px 0;
      font-weight: 500;
      color: #333333;
      text-align: center;
      line-height: 38px;
      font-size: 18px;

      .top {
        text-align: center;
        height: 24px;
        line-height: 24px;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin-bottom: 5px;
      }

      .bot {
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
        text-align: center;
      }

      span {
        position: absolute;
        color: #999;
        right: 24px;
        top: 25px;
        width: 13px;
        height: 13px;
        cursor: pointer;
        background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .contentBox {
      padding: 28px 110px 20px;

      .addressList {
        margin-bottom: 20px;
        line-height: 22px;
        height: 22px;

        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 1px solid #979797;
          border-radius: 50%;
          margin-right: 10px;
          vertical-align: middle;
          cursor: pointer;
          position: relative;

          i {
            position: absolute;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #2026CC;
            left: 50%;
            top: 50%;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
          }
        }

        span.notC {
          border: 1px solid #BFBFBF;
        }

        .name {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          margin-right: 30px;
          vertical-align: middle;
          width: 390px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
          cursor: pointer;
        }

        i.notC {
          color: #BFBFBF;
        }

        .xiugai {
          font-size: 16px;
          font-weight: 400;
          color: #2026CC;
          cursor: pointer;
          margin-right: 10px;
          vertical-align: middle;
        }
        .shanchu{
          font-size: 16px;
          font-weight: 400;
          color: #2026CC;
          cursor: pointer;
          vertical-align: middle;
        }
      }

      .addAddress {
        cursor: pointer;
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #2026CC;
        line-height: 22px;
        text-align: right;
        margin-bottom: 20px;
      }

      .city {
        text-align: center;
        margin-bottom: 20px;

        span {
          margin-right: 17px;
          display: inline-block;
          width: 120px;
          text-align: right;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
        }

        .inputTitle {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          margin-bottom: 20px;
        }
      }
    }
    .contentBox1{
      padding: 21px 110px 40px;
      .title1{
        color: #333;
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
      }
      .title2{
        color: #333;
        font-size: 14px;
        font-weight: 600;
        margin-top: 30px;
        line-height: 24px;
      }
      p{
        font-size: 12px;
        color: #333;
        font-weight: 400;
        line-height: 24px;
      }
    }
    .but {
      text-align: center;

      span {
        padding: 0 35px;
        hight: 40px;
        background: #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        display: inline-block;
      }
    }
  }
  .box1{
    width: 635px;
    .contentBox2{
      padding: 30px 40px 0;
      .p1{
        height: 24px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        margin-bottom: 15px;
        i{
          color: rgba(221, 41, 0, 1);
        }
      }
      .p2{
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        i{
          color: rgba(221, 41, 0, 1);
        }
      }
      .p3{
        font-size: 16px;
        font-weight: 400;
        color: #999;
        line-height: 24px;
        span{
          color: rgba(51, 51, 51, 1);
          margin-left: 5px;
        }
      }
      .but1{
        text-align: center;
        margin-top: 32px;
        span{
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
        }
        .closePop{
          width: 117px;
          height: 40px;
          border: 1px solid #2026CC;
          line-height: 40px;
          font-size: 16px;
          font-weight: 600;
          color: #2026CC;
          margin-right: 10px;
          box-sizing: border-box;
        }
        .config{
          width: 117px;
          height: 40px;
          background: #2026CC;
          line-height: 40px;
          font-size: 16px;
          font-weight: 600;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/releasePosition.vue